import { Card, Drawer, Space, Switch } from 'antd'
import {
  DrilldownExplorationPicker,
  DrilldownExplorationPickerProps,
} from 'features/drilldown/components/settings/DrilldownExplorationPicker'
import { ExplorationNavigationButtons } from 'features/drilldown/components/settings/ExplorationNavigationButtons'
import React, { Dispatch, SetStateAction, useCallback } from 'react'
import styled from 'styled-components'

const SettingsItem = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`

interface DrilldownSettingsViewProps {
  isSettingsDrawerOpen: boolean
  setIsSettingsDrawerOpen: Dispatch<SetStateAction<boolean>>
  isPresentationModeEnabled: boolean
  setIsPresentationModeEnabled: Dispatch<SetStateAction<boolean>>
  loading?: boolean
  explorationPickerProps?: DrilldownExplorationPickerProps
}

export const DrilldownSettingsView: React.FC<DrilldownSettingsViewProps> = ({
  isSettingsDrawerOpen,
  setIsSettingsDrawerOpen,
  isPresentationModeEnabled,
  setIsPresentationModeEnabled,
  loading,
  explorationPickerProps,
}) => {
  return (
    <Drawer
      title='Settings'
      autoFocus
      size={580}
      onClose={useCallback(
        () => setIsSettingsDrawerOpen(false),
        [setIsSettingsDrawerOpen]
      )}
      mask
      maskClosable
      open={isSettingsDrawerOpen}>
      <Space orientation='vertical' size='middle'>
        <Card title='New Exploration'>
          <ExplorationNavigationButtons
            unlinkCurrentExploration={
              explorationPickerProps?.unlinkCurrentExploration
            }
          />
        </Card>
        <Card title='Display Settings'>
          <SettingsItem>
            <span>Show Unpinned Sections</span>
            <Switch
              value={!isPresentationModeEnabled}
              onChange={useCallback(
                (value: boolean) => setIsPresentationModeEnabled(!value),
                [setIsPresentationModeEnabled]
              )}
              disabled={!!loading}
            />
          </SettingsItem>
        </Card>
        <Card title='Saving and Loading'>
          <SettingsItem>
            {!!explorationPickerProps && (
              <>
                <span>Saved Explorations</span>
                <DrilldownExplorationPicker {...explorationPickerProps} />
              </>
            )}
          </SettingsItem>
        </Card>
      </Space>
    </Drawer>
  )
}
